// extracted by mini-css-extract-plugin
export var active = "PartnersGridItem-module--active--c1762";
export var hoverContent = "PartnersGridItem-module--hover-content--ea27e";
export var partner = "PartnersGridItem-module--partner--b2e54";